/**
 * Connection types for studio devices
 */
export const CONNECTION_TYPES = [
    "videohub",
    "atem",
    "behringer_wing",
    "dlive",
    "companion",
    "vmix",
    "generic",
];
/**
 * Default ports for each connection type
 */
export const DEFAULT_PORTS = {
    videohub: 9990,
    atem: 9910,
    behringer_wing: 2222,
    dlive: 51325,
    companion: 8000,
    vmix: 8088,
    generic: 80,
};
/**
 * Display names for connection types
 */
export const CONNECTION_TYPE_LABELS = {
    videohub: "Blackmagic VideoHub",
    atem: "ATEM Mixer",
    behringer_wing: "Behringer Wing",
    dlive: "Allen & Heath dLive",
    companion: "Bitfocus Companion",
    vmix: "vMix",
    generic: "Generic Device",
};
